import { HandshakeIcon, HardHatIcon, NotePencilIcon, TruckIcon } from '@fronton/icons-react';
import { ReviewBenefitStructure, ReviewStructure } from 'common/components';

export const CABINET_PATH = '/uslugi/proektirovanie-i-dizayn/shkafy-na-zakaz/';

export const CABINET_ELEMENT_BLOCK = 'landingWardrobes';

export const CABINET_CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/cabinet';

export const CABINET_LANDING_NAME = 'cabinet';

export const CABINET_HEADER_IMAGE_LIST = [
  {
    ldSrcSet: `${CABINET_CDN_PATH}/header/header-ld.jpg/header-ld.jpg`,
    dSrcSet: `${CABINET_CDN_PATH}/header/header-d.jpg/header-d.jpg`,
    tSrcSet: `${CABINET_CDN_PATH}/header/header-t.jpg/header-t.jpg`,
    mSrcSet: `${CABINET_CDN_PATH}/header/header-m.jpg/header-m.jpg`,
    alt: 'Изображение шкафа',
  },
  {
    ldSrcSet: `${CABINET_CDN_PATH}/header/2-ld.jpg/2-ld.jpg`,
    dSrcSet: `${CABINET_CDN_PATH}/header/2-d.jpg/2-d.jpg`,
    tSrcSet: `${CABINET_CDN_PATH}/header/2-t.jpg/2-t.jpg`,
    mSrcSet: `${CABINET_CDN_PATH}/header/2-m.jpg/2-m.jpg`,
    alt: 'Изображение шкафа с зеркальными дверьми',
  },
  {
    ldSrcSet: `${CABINET_CDN_PATH}/header/3-ld.jpg/3-ld.jpg`,
    dSrcSet: `${CABINET_CDN_PATH}/header/3-d.jpg/3-d.jpg`,
    tSrcSet: `${CABINET_CDN_PATH}/header/3-t.jpg/3-t.jpg`,
    mSrcSet: `${CABINET_CDN_PATH}/header/3-m.jpg/3-m.jpg`,
    alt: 'Изображение гардеробной',
  }
];

export const CABINET_REVIEWS_BENEFITS: ReviewBenefitStructure[] = [
  {
    icon: NotePencilIcon,
    text: 'Сделаем дизайн-проект\nи\u00A0точные замеры',
  },
  {
    icon: HandshakeIcon,
    text: 'Подготовим и\u00A0заключим\nс\u00A0вами договор',
  },
  {
    icon: TruckIcon,
    text: 'Изготовим и\u00A0доставим\nзаказ домой',
  },
  {
    icon: HardHatIcon,
    text: 'Соберём всё быстро\nи\u00A0качественно',
  },
]

export const CABINET_REVIEWS_DATA: ReviewStructure[] = [
  {
    imagesAlt: 'Review 1',
    images: [`${CABINET_CDN_PATH}/reviews/review-1-1.jpg/review-1-1.jpg`],
    bigImages: ['cabinet/reviews/big/review-1-1.jpg/review-1-1.jpg'],
    rating: 5,
    text:
      'Добрый день. Заказали шкафы в\u00A0коридор. Случайно увидели в\u00A0Лемана ПРО, что есть шкафы на\u00A0заказ. Вместе с\u00A0продавцом Светланой все тщательно построили в\u00A0специальной программе. Цена оказалось очень даже приемлемой. Изготовили все в\u00A0срок. Вопросов и\u00A0претензий во\u00A0время сборки не\u00A0было.',
    date: 'февраль 2024',
  },
  {
    imagesAlt: 'Review 2',
    images: [`${CABINET_CDN_PATH}/reviews/review-2-1.jpg/review-2-1.jpg`],
    bigImages: ['cabinet/reviews/big/review-2-1.jpg/review-2-1.jpg'],
    rating: 5,
    text:
      'Изготовление, доставка, сборка на\u00A0высшем уровне! После печального опыта заказа мебели в\u00A0другом магазине, была очень насторожена. Но\u00A0к\u00A0моему счастью, все прошло отлично, вчера нам установили 2\u00A0гардеробки.',
    date: 'июль 2024',
  },
  {
    imagesAlt: 'Review 3',
    images: [`${CABINET_CDN_PATH}/reviews/review-3-1.jpg/review-3-1.jpg`],
    bigImages: ['cabinet/reviews/big/review-3-1.jpg/review-3-1.jpg'],
    rating: 5,
    text:
      'Долго думали, где заказать шкаф по\u00A0своим размерам. По\u00A0рекомендации знакомых, пошли в\u00A0Лемана ПРО. Далее в\u00A0магазине все выбрали и\u00A0вместе с\u00A0продавцом построили шкаф, который нужен. Шкаф сделали раньше заявленного срока. Служба доставки согласовали время, привезли все в\u00A0срок, аккуратно занесли.',
    date: 'август 2024',
  },
  {
    imagesAlt: 'Review 4',
    images: [`${CABINET_CDN_PATH}/reviews/review-4-1.jpg/review-4-1.jpg`],
    bigImages: ['cabinet/reviews/big/review-4-1.jpg/review-4-1.jpg'],
    rating: 5,
    text:
      'Гардеробную заказали через Лемана ПРО г. Красногорска (тот что на\u00A0Риге). Быстрота изготовления, доставка и\u00A0сборка на\u00A0высшем уровне',
    date: 'апрель 2024',
  },
  {
    imagesAlt: 'Review 5',
    images: [`${CABINET_CDN_PATH}/reviews/review-5-1.jpg/review-5-1.jpg`],
    bigImages: ['cabinet/reviews/big/review-5-1.jpg/review-5-1.jpg'],
    rating: 5,
    text:
      'Благодарю сборщика из\u00A0Лемана! Золотые руки! Быстро, качественно ! Шикарный шкаф купе 3\u00A0метра высота! С\u00A0гардеробной системой!',
    date: 'ноябрь 2024',
  },
  {
    imagesAlt: 'Review 6',
    images: [`${CABINET_CDN_PATH}/reviews/review-6-1.jpg/review-6-1.jpg`],
    bigImages: ['cabinet/reviews/big/review-6-1.jpg/review-6-1.jpg'],
    rating: 5,
    text:
      'Заказали встроенный шкаф в\u00A0комнату. Ниша уже была готова. Шкаф делали 20\u00A0дней. К\u00A0сожалению двери были изготовлены с\u00A0ошибками. Поэтому сначала собрали внутренности. Двери ждали еще недели две. Собрали идеально. Рассказали и\u00A0показали как ухаживать за\u00A0дверьми. Спасибо!',
    date: 'январь 2024',
  },
  {
    imagesAlt: 'Review 7',
    images: [`${CABINET_CDN_PATH}/reviews/review-7-1.jpg/review-7-1.jpg`],
    bigImages: ['cabinet/reviews/big/review-7-1.jpg/review-7-1.jpg'],
    rating: 5,
    text:
      'После ремонта нужен был шкаф в\u00A0прихожую. Искали, смотрели во\u00A0многих мебельных магазинах. В\u00A0итоге увидели в\u00A0Лемана ПРО\u00A0то, что нужно. Вместе с\u00A0менеджером прям в\u00A0магазине все спроектировали. Учли все пожелания. По\u00A0срокам производство вовремя. По\u00A0готовности позвонил диспетчер и\u00A0согласовали дату доставки и\u00A0монтажа. Доставка привезла вовремя, предельно аккуратно подняли и\u00A0занесли упаковки. Рекомендуем!',
    date: 'сентябрь 2024',
  },
  {
    imagesAlt: 'Review 8',
    images: [`${CABINET_CDN_PATH}/reviews/review-8-1.jpg/review-8-1.jpg`],
    bigImages: ['cabinet/reviews/big/review-8-1.jpg/review-8-1.jpg'],
    rating: 5,
    text:
      'Заказала Гардероб в\u00A0Лемана ПРО, привезли вовремя, сборка состоялась на\u00A0следующий день. Сборщик мебели, все собрал аккуратно, претензий нет. Очень отзывчивый и\u00A0интеллигентный мужчина! Спасибо!',
    date: 'март 2024',
  },
];

export const CABINET_LANDINGS_INFO = [
  {
    landingName: 'cabinet',
    isAvailable: true,
    categoryId: 1526,
    presaleType: 'CABINET',
    presaleSubChannel: '',
    url: '/uslugi/proektirovanie-i-dizayn/shkafy-na-zakaz/',
    defaultTitle: 'Шкафы, дверии гардеробные на заказ',
    addTitle: 'Шкафы, дверии гардеробные на заказ',
    description: '',
    imageSrc: '',
    imageAlt: 'Шкафы, дверии гардеробные на заказ',
    otherSection: [
      'modular-system-lion',
      'metal-wardrobe',
      'spaceo-kub',
    ]
  },
  {
    landingName: 'modular-system-lion',
    isAvailable: true,
    categoryId: 1526,
    presaleType: 'MODULAR_SYSTEM_LION',
    presaleSubChannel: '',
    url: '/search/?q=шкаф%20лион&suggest=true',
    defaultTitle: 'Модульная система шкафов «Лион»',
    addTitle: 'Модульная система шкафов «Лион»',
    description: '',
    imageSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/cabinet/other/modular-system-lion.jpg/modular-system-lion.jpg',
    imageAlt: 'Модульная система шкафов «Лион»',
    otherSection: []
  },
  {
    landingName: 'metal-wardrobe',
    isAvailable: true,
    categoryId: 1526,
    presaleType: 'METAL_WARDROBE',
    presaleSubChannel: '',
    url: '/catalogue/garderobnye-sistemy/',
    defaultTitle: 'Металлические гардеробные системы',
    addTitle: 'Металлические гардеробные системы',
    description: '',
    imageSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/cabinet/other/metal-wardrobe.jpg/metal-wardrobe.jpg',
    imageAlt: 'Металлические гардеробные системы',
    otherSection: []
  },
  {
    landingName: 'spaceo-kub',
    isAvailable: true,
    categoryId: 1526,
    presaleType: 'SPACEO_KUB',
    presaleSubChannel: '',
    url: '/promo/spaceo-kub/',
    defaultTitle: 'Система хранения KUB',
    addTitle: 'Система хранения KUB',
    description: '',
    imageSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/cabinet/other/spaceo-kub.jpg/spaceo-kub.jpg',
    imageAlt: 'Система хранения KUB',
    otherSection: []
  },
];
